export default "__VITE_ASSET__CaJJhS0B__"